import React from "react";
import {
    Card,
    CardProps,
    CardContent,
    ThemeProvider,
    Theme,
    StyledEngineProvider,
    Typography,
    Box,
} from "@mui/material";
import { verbalTheme } from "../../components/layout/themes/verbal.theme";

declare module "@mui/styles/defaultTheme" {
    // eslint-disable-next-line @typescript-eslint/no-empty-interface
    interface DefaultTheme extends Theme {}
}

type VCardProps = CardProps & {
    title?: string;
    subtitle?: string;
    children: React.ReactNode;
};

export const VCard: React.FC<VCardProps> = (props: VCardProps): JSX.Element => {
    const { title, subtitle, children, ...rest } = props;

    return (
        <StyledEngineProvider injectFirst>
            <ThemeProvider theme={verbalTheme}>
                <Card {...rest}>
                    <CardContent>
                        <Box mb={2}>
                            {title && <Typography variant="h6">{title}</Typography>}
                            {subtitle && <Typography variant="body2">{subtitle}</Typography>}
                        </Box>
                        {children}
                    </CardContent>
                </Card>
            </ThemeProvider>
        </StyledEngineProvider>
    );
};
